import { defineMessages } from 'react-intl';

const messages = defineMessages({
  requiredFieldErrorMessage: {
    id: 'boxFileRequest.requiredField.errorMessage',
    description: 'Message for missing value',
    defaultMessage: 'This field is required',
  },
  requiredUploadFieldErrorMessage: {
    id: 'boxFileRequest.requiredUploadField.errorMessage',
    description: 'Message for missing files',
    defaultMessage: 'Please add files.',
  },
  invalidEmailFieldErrorMessage: {
    id: 'boxFileRequest.invalidEmailField.errorMessage',
    description: 'Message for invalid email',
    defaultMessage: 'Invalid email address',
  },
  notANumberErrorMessage: {
    id: 'boxFileRequest.notANumber.errorMessage',
    description: 'Message for not a number',
    defaultMessage: 'Not a number',
  },
  formIncompleteErrorMessage: {
    id: 'boxFileRequest.formSubmitter.formIncompleteErrorMessage',
    description: 'Message for incomplete form error',
    defaultMessage: 'Please complete all required fields.',
  },
  tooManyFilesMessage: {
    id: 'boxFileRequest.formSubmitter.tooManyFilesMessage',
    description:
      'Message for too many files, where limit is the max number of files',
    defaultMessage:
      'The maximum number of files that can be submitted is {limit}.',
  },
  fileSizeLimitExceeded: {
    id: 'boxFileRequest.formSubmitter.fileSizeLimitExceeded',
    description:
      'Message for when files list includes file with size bigger than size limit',
    defaultMessage:
      'One or more files exceed the {size} limit and could not be added.',
  },
  invalidFileNameMessage: {
    id: 'boxFileRequest.formSubmitter.invalidFileName',
    description:
      'Message for when files list includes file with invalid or non-printable UTF-8 characters in name.',
    defaultMessage:
      'Failed to add files because filenames contained unsupported characters. Please check filenames and try again.',
  },
  itemsFilteredFromAddMessage: {
    id: 'boxFileRequest.formSubmitter.itemsFilteredFromAddMessage',
    description:
      'Message for when files were filtered out from being added to a drop zone',
    defaultMessage:
      'One or more files could not be added as they have already been added to your submission',
  },
  submissionFailedMessage: {
    id: 'boxFileRequest.formSubmitter.submissionFailedMessage',
    description: 'Message to display on submission errors',
    defaultMessage:
      'Oops something went wrong with your submission. Please refresh the page and try again.',
  },
  specialCharacters: {
    id: 'boxFileRequest.formSubmitter.specialCharacters',
    description:
      'Message to display on input field when user submits form field with invalid characters',
    defaultMessage: 'Form field contains unsupported characters',
  },
  specialCharactersNotification: {
    id: 'boxFileRequest.formSubmitter.specialCharactersNotification',
    description:
      'Message to display in notification toast when user submits form field with invalid characters',
    defaultMessage:
      'Failed to submit because fields contained unsupported characters. Please check fields and try again.',
  },
  maximumSelectionsExceeded: {
    id: 'boxFileRequest.formSubmitter.maximumSelectionsExceeded',
    description:
      'Message to display on list field when maximum number of selections has been exceeded',
    defaultMessage: 'Maximum number of selections exceeded.',
  },
  fileDescriptionErrorMessage: {
    id: 'boxFileRequest.formSubmitter.fileDescriptionErrorMessage',
    description: 'Error message for when a file description is missing',
    defaultMessage: 'Please provide a file description',
  },
  uploadRequiresFiles: {
    id: 'boxForm.formSubmitter.uploadFieldRequiresFiles',
    description: 'Upload Field Requires Files',
    defaultMessage: 'Please upload required file(s)',
  },
  formGenericErrorMessage: {
    id: 'boxForm.formSubmitter.formGenericErrorMessage',
    description:
      'Generic error message to display when there are undesired input errors in a Form to address',
    defaultMessage: 'Please resolve any errors in your Form to proceed.',
  },
});

export default messages;
